<template>
  <div v-loading="musciLoading" class="music">
    <div class="select-music">选择音频</div>
    <div class="drop-out" @click="musicout">
      <img alt="" :src="g_imgSrc.delete" class="out" @click="musicout" />
    </div>
    <div style="overflow: hidden">
      <tagSelect v-if="type === 'public'" class="tag-select" @emitAddPublic="emitAddPublic" />
      <tagSelectAgent v-else class="tag-select" @emitAddPublic="emitAddPublic" />
      <div class="music-updata">
        <el-button @click="uploadaudio">上传音频</el-button>
      </div>
    </div>
    <div v-if="datalist.length > 0" class="music-list">
      <div
        :key="data.mate_id"
        class="box"
        v-for="data in datalist"
        :class="{ isSelect: data.select }"
      >
        <img alt="" :src="g_imgSrc.audio" class="music-box-img" />
        <span
          class="button-select"
          :class="{ isSelect: data.select }"
          @click="changeSelect(data)"
        />
        <!-- <img alt="" v-if="!data.select" :src="g_imgSrc.webUnSelected" class="item-select cursor" @click="changeSelect(data)">
                <img alt="" v-else :src="g_imgSrc.webSelected" class="item-select cursor" @click="changeSelect(data)"> -->
        <div class="music-title">
          {{ data.mate_name }}
        </div>
        <audio class="music-box" :src="data.mate_data" controls="controls" />
        <statusTag :list="data.agents" v-if="data.agents.length" />
      </div>
    </div>
    <div v-if="datalist.length === 0" class="noDatalist">
      <img alt="" :src="g_imgSrc.bgWhite" class="noDatalist-img" />
      <div class="release-list-noData-word">暂无相关内容</div>
    </div>
    <el-pagination
      v-if="datalist.length > 0"
      class="pagination"
      style="background-color: #ffffff"
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="size"
      @current-change="handleCurrentChange"
    />
    <div slot="footer" class="dialog-footer" v-if="datalist.length > 0">
      <el-button class="closeCancel" @click="musicout">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { EyaoSaaSSelectMaterialApi } from '@/api/releaseManagement';
import tagSelectAgent from '@/components/tagSelectAgent';
import tagSelect from '@/components/tagSelect';
import statusTag from '@/components/statusTag';
export default {
  components: { tagSelect, tagSelectAgent, statusTag },
  props: {
    type: {
      type: String,
      default: 'public',
    },
    musicClose: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      file_type: 3, //  1->图片   3->音频   2->视频
      total: 1, // 总页数
      size: 9, // 每页数量
      currentPage: 1, // 页数
      musciLoading: false, // loading
      datalist: [], // 列表数组
      sortList: [], // 勾选为true的数组
      agentIds: [],
    };
  },
  mounted() {
    this.getdataList();
  },
  methods: {
    emitAddPublic(list) {
      this.agentIds = list.map((item) => item.value);
      this.getdataList(1);
    },
    // 获取列表数据
    getdataList(page) {
      if (page) {
        this.currentPage = page;
      }
      let mode = 1;
      if (this.type === 'public') {
        mode = 1;
      } else if (this.type === 'app') {
        mode = 2;
      }
      this.musciLoading = true;
      const req = {
        mate_type: this.file_type,
        page_size: this.size,
        page_index: this.currentPage,
        appids: this.type === 'public' ? this.agentIds : [],
        agent_ids: this.type !== 'public' ? this.agentIds : [],
        mode,
      };
      EyaoSaaSSelectMaterialApi(req)
        .then((res) => {
          this.total = res.total;
          this.datalist = res.mate_list.map((item) => {
            item = Object.assign(item, { select: false });
            return item;
          });
          this.musciLoading = false;
        })
        .catch(() => {
          this.musciLoading = false;
          this.$message('查询失败');
        });
    },
    // 勾选
    changeSelect(i) {
      this.datalist = this.datalist.map((item) => {
        if (item.mate_id === i.mate_id) {
          item.select = !item.select;
          if (item.select) {
            this.sortList.push(item);
          } else {
            const arr = [];
            this.sortList.forEach((soltItem) => {
              if (soltItem.mate_id !== i.mate_id) {
                arr.push(soltItem);
              }
            });
            this.sortList = arr;
          }
        }
        return item;
      });
    },
    // 上传音频
    async uploadaudio() {
      this.g_tourl(`/saas/materialManagement/material-audio-upload.html`, { open: true });
    },
    confirm() {
      // this.dialogVisible = false;
      this.musicClose();
      this.$emit('musicDatalist', this.sortList);
    },
    // 选择页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.musciLoading = true;
      let mode = 1;
      if (this.type === 'public') {
        mode = 1;
      } else if (this.type === 'app') {
        mode = 2;
      }
      const req = {
        mate_type: this.file_type,
        page_size: this.size,
        page_index: this.currentPage,
        appids: this.type === 'public' ? this.agentIds : [],
        agent_ids: this.type !== 'public' ? this.agentIds : [],
        mode,
      };
      EyaoSaaSSelectMaterialApi(req)
        .then((res) => {
          this.datalist = res.mate_list.map((item) => {
            item = Object.assign(item, { select: false });
            return item;
          });
          if (this.sortList.length > 0) {
            this.datalist = this.datalist.map((item) => {
              item = Object.assign(item, { select: false });
              this.sortList.forEach((sortItem) => {
                if (sortItem.mate_id === item.mate_id) {
                  item.select = true;
                }
              });
              return item;
            });
          }
          this.musciLoading = false;
        })
        .catch(() => {
          this.musciLoading = false;
          this.$message('查询失败');
        });
    },
    musicout() {
      this.sortList = [];
      this.musicClose();
    },
  },
};
</script>
<style scoped lang="scss">
.music {
  .tag-select {
    width: 80%;
    float: left;
    margin: 49px 0 0 20px;
  }
  .select-music {
    font-size: 16px;
    margin-left: 32px;
  }
  .drop-out {
    height: 18px;
    width: 20px;
    position: absolute;
    top: 30px;
    right: 45px;
    cursor: pointer;
    .out {
      width: 100%;
      cursor: pointer;
    }
  }
  .music-list {
    margin: 20px -15px 0 20px;
    .box {
      position: relative;
      width: 290px;
      height: 164px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      display: inline-block;
      margin-right: 15px;
      margin-bottom: 10px;
      border-radius: 4px;
      overflow: hidden;
      .music-box-img {
        background-color: gray;
        height: 88px;
        object-fit: cover;
        width: 88px;
        border-radius: 4px;
      }
      &.isSelect {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: rgba(47, 150, 255, 0.15);
          border: 2px solid #2f96ff;
          border-radius: 4px;
        }
      }
      .button-select {
        position: absolute;
        background: rgba(48, 49, 51, 0.1);
        border: 1px solid #c0c4cc;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        right: 10px;
        top: 10px;
        z-index: 9;
        cursor: pointer;
        &.isSelect {
          background: #2f96ff;
          border: 1px solid #ffffff;
          &::after {
            content: '';
            width: 8px;
            height: 8px;
            position: absolute;
            left: 50%;
            top: 50%;
            border-radius: 50%;
            margin: -4px 0 0 -4px;
            background: #ffffff;
          }
        }
      }
      .item-select {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 14px;
        left: 13px;
        font-size: 16px;
        cursor: pointer;
      }
      .title {
        width: 140px;
        height: 20px;
        position: absolute;
        top: 12px;
        left: 50px;
        font-size: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .music-title {
        height: 24px;
        position: absolute;
        top: 13px;
        left: 97px;
        font-size: 16px;
        color: #303133;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 170px;
      }
      .music-box {
        position: absolute;
        right: -69px;
        top: 41px;
        width: 352px;
        height: 60px;
        transform: scaleX(0.5) scaleY(0.5);
      }
    }
    .box:hover {
      border: 1px solid #2f96ff;
    }
  }
  .noDatalist {
    width: 100%;
    text-align: center;
    .noDatalist-img {
      width: 240px;
      height: 192px;
      margin-top: 10vh;
    }
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: center;
    .closeCancel {
      border: 1px solid #dcdfe6;
      background: #ffffff;
      color: #606266;
    }
    .closeCancel:hover {
      background: rgba(0, 0, 0, 0.04);
      color: #606266;
    }
  }
  .dialog-footer ::v-deep .el-button span {
    font-weight: normal;
  }
  .pagination {
    text-align: right;
    margin-top: 20px;
  }
  .pagination ::v-deep .el-pager li.number {
    color: #606266;
  }
  .pagination ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }
  .pagination ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
}
.el-button--primary:hover {
  background: #63b0ff;
  color: #ffffff;
}
</style>
